// src/components/PlanSelector.tsx
import React, { useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import SubscriptionCard from './SubscriptionCard';
import { getProductPlanList, getProductPlanListWeb } from '../../services/apiService';
import { PlanData } from '../../services/types';
import { FormControlLabel, Radio } from '@mui/material';
import './Subscription.css'
import LoaderWithBackdrop from "../Loader/loader";


const PlanSelector: React.FC = () => {
  const paramsUserId = new URLSearchParams(window.location.search).get("userId");
  const userId = paramsUserId || localStorage.getItem("userId");
  const [plans, setPlans] = React.useState<PlanData[]>([]);
  const method = new URLSearchParams(window.location.search).get("method");
  const encryptRedirectToken = new URLSearchParams(window.location.search).get("encryptRedirectToken");
  const [selectedCurrency, setSelectedCurrency] = React.useState(method || "INR");
  const [loading, setLoading] = React.useState(false);
  // const isProd = process.env.REACT_APP_ENV !== 'prod';

  const handleCurrencyChange = (event: any) => {
    setSelectedCurrency(event.target.value);
  };


  useEffect(() => {
    const fetchGeneratedImages = async () => {
      setLoading(true)
      const response =  encryptRedirectToken ? await getProductPlanList("tryon"): await getProductPlanListWeb();
      setLoading(false);
      if (response.status === 'success') {
        setLoading(false);
        // console.log(response.data);
        setPlans(response.data);
      }
    }
    fetchGeneratedImages();
  }, [userId]);
  return (
    <Box className="pricing-container">
      {loading && <LoaderWithBackdrop open={loading}/>}
      <Grid container spacing={4} maxWidth="100%" className="planSelector">
        {/* Left Side */}
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Our Pricing
            </Typography>
            <Typography>
              {encryptRedirectToken ? "Get 5 free trials when you sign up. After that, you can purchase credits — each image generation costs 75 credits." :
              "We have no subscription model as we don't want to lock you in the platform. Our pricing is simple. Just buy the credits and use them; they expire in 1 year. We strive to retain users based on the quality of the platform and not by locking them in. Training models cost 2000+ credits, depending on training settings. Each generation costs 25 credits. Video generation costs 100 credits for 5 seconds."}
            </Typography>
          </Box>
        </Grid>

        {/* Right Side */}
        {!method && (
          <Grid item xs={12} md={6} className="currencySelector">
          <Box>
            <Typography variant="h6" gutterBottom className='currency-text'>
              Please select your currency
            </Typography>
          </Box>
          <Box>
            {/* INR Option */}
            <FormControlLabel
              value="INR"
              checked={selectedCurrency === "INR"}
              control={<Radio sx={{ color: "#fff" }} />}
              onChange={handleCurrencyChange}
              label={
                <Box className="flag-container">
                  <img
                    src="https://flagcdn.com/w40/in.png"
                    alt="INR"
                    className='flag-icon'
                  />
                  <Typography color="#fff">INR</Typography>
                </Box>
              }
            />

            {/* USD Option */}
            <FormControlLabel
              value="USD"
              checked={selectedCurrency === "USD"}
              control={<Radio sx={{ color: "#fff" }} />}
              onChange={handleCurrencyChange}
              label={
                <Box className="flag-container">
                  <img
                    src="https://flagcdn.com/w40/us.png"
                    alt="USD"
                    className='flag-icon'
                  />
                  <Typography color="#fff">US DOLLAR</Typography>
                </Box>
              }
            />
            {/* payment text */}
            <Box>
              <Typography className='payment-text'>
               Payment will be processed through PhonePe, UPI and Stripe.
              </Typography>
            </Box>
          </Box>

        </Grid>
        )}
      </Grid>


      {/* <ToggleButtonGroup exclusive sx={{ mb: 4 }}>
        <ToggleButton value="personal" selected>
          Personal
        </ToggleButton>
        <ToggleButton value="business">Business</ToggleButton>
      </ToggleButtonGroup> */}

      <Grid style={{ height: "500px" }} container spacing={4} justifyContent="flex-start" width={'100%'}>
        {plans
          .sort((a, b) => a.position - b.position) // Sort by position
          .map((plan: PlanData) => (
            <Grid item key={plan.name} xs={12} sm={6} md={3} xl={2}>
              <SubscriptionCard {...plan} selectedCurrency={selectedCurrency} encryptRedirectToken={encryptRedirectToken} paramsUserId={paramsUserId}/>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default PlanSelector;
